// core/error/error.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, ErrorHandler, Injector } from '@angular/core';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const injector = inject(Injector);
  return next(req).pipe(
    catchError(err => {
    const eh = injector.get(ErrorHandler);
      (err as any).__handledByGlobalEh = true;
      eh.handleError(err);
      return throwError(() => err);
    })
  );
};
